<template>
  <div class="card">
    <div class="card-image">
      <figure class="image is-4by3">
        <img v-bind:src="user.spaceship_image" alt="Spaceship">
      </figure>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-left">
          <figure class="image is-48x48">
            <img v-bind:src="user.avatar" alt="Avatar">
          </figure>
        </div>
        <div class="media-content">
          <p class="title is-5">{{ user.name }}</p>
          <p class="subtitle is-7">@{{ user.username }}</p>
        </div>
      </div>

      <div class="content">
          <p>
            <small>
              <strong>Баланс:</strong>
              {{ user.balance }} кр.
            </small>
          <br>
            <small>
              <strong>Обучение:</strong>
              <span v-if="activeLearning">
                {{ activeLearning.skill.name }} ({{ activeLearning.completion_rate }}%)
              </span>
              <span v-else>Нет</span>
            </small>
          </p>
        </div>
      </div>

      <div class="content" v-if="user.ship">
        <p><progress class="progress is-small" v-bind:class="currentStrength" v-bind:value="user.ship.current_strength" v-bind:max="user.ship.strength">{{ user.ship.current_strength }}</progress></p>
        {{ user.ship.current_strength }}
      </div>

      <div class="content" v-if="user.ship">
        <p><progress class="progress is-small" v-bind:class="currentStrength" v-bind:value="user.ship.current_strength" v-bind:max="user.ship.strength">{{ user.ship.current_strength }}</progress></p>
        {{ user.ship.current_strength }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['user'],
  data: function () {
    return {
      // currentStrength: this.user.ship.current_strength,
    }
  },
  computed: {
    activeLearning () {
      return (this.user.user_learnings || []).find(l => l.status === 'active') || null
    },
    currentStrength: function () {
      if (this.user.ship.current_strength > this.user.ship.strength * 0.5) {
        return 'is-success'
      } else if (this.user.ship.current_strength > this.user.ship.strength * 0.2) {
        return 'is-warning'
      } else {
        return 'is-danger'
      }
    }
  }
}
</script>
